import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  Renderer2,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-compact-header-container',
  templateUrl: './compact-header-container.component.html',
  styleUrls: ['./compact-header-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompactHeaderContainerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('header') header: ElementRef | undefined;
  @ViewChild('buffer') buffer: ElementRef | undefined;

  private renderer = inject(Renderer2);
  private observer = new ResizeObserver(() => {
    const headerHeight = this.header?.nativeElement?.offsetHeight + 'px';
    this.renderer.setStyle(this.buffer?.nativeElement, 'height', headerHeight);
  });

  public ngAfterViewInit() {
    this.observer.observe(this.header?.nativeElement);
  }

  public ngOnDestroy() {
    this.observer.disconnect();
  }
}
